<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Monthly visitor count</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Visitor count</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="organizations-organizations">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <button class="btn btn-info" type="button" @click="showFilter = !showFilter">
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>
            <div class="btn-toolbar pull-right">

            </div>
          </div>
          <form @submit.prevent="setFilter" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="org_name">Year</label>
                    <div class="col-md-9">
                      <el-select
                        v-model="filter.year"
                        name="difficulty_level"
                        placeholder="Select year"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in [
                                { value: '2023', label: '2023' },
                                { value: '2024', label: '2024'},
                                { value: '2025', label: '2025'},
                              ]"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px"><i class="fas fa-search"></i> Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>

          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th>Month</th>
                <th>No Of Users</th>
                <th class="text-right">Action</th>
              </tr>
              </thead>
              <tbody class="organizations-organizations">
              <tr v-for="(val, index) in visitors">
                <td>{{ val.month | monthName }}</td>
                <td>{{ val.count }}</td>
                <td class="text-right">
                  <button class="btn btn-info btn-sm m-2px" @click="$emit('visitors-list', val.month)">
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="col-12 p-4" v-if="_.isEmpty(visitors)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <monthly-visitors/>

  </div>
</template>

<script>
import {CommonAPI} from '@/services/api'
import SortIcons from "@/components/utils/SortIcons.vue";

export default {
  name: 'MonthlyVisitorCount',
  metaInfo: {
    title: "Monthly visitor | Dotlines"
  },
  components: {
    SortIcons,
    MonthlyVisitors: () => import('./components/MonthlyVisitorsModal.vue')
  },
  data: () => ({
    visitors: {},
    filter: {},
    showFilter: false,
    is_loading: false
  }),
  methods: {
    getVisitors() {
      this.is_loading = true
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.showFilter = true
      //let params = { ...this.filter, ...this.$route.query }

      CommonAPI.monthlyVisitorCount(this.filter).then(visitors => {
        this.visitors = visitors
      }).catch(error => {
        console.log('error: ', error)
      }).finally(() => {
        this.is_loading = false
      })
    },

    setFilter() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter
        })
        .catch((err) => {
          //console.log(err)
        })
    },

    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {
      })
    }
  },
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    }
    this.getVisitors()
  },

  filters: {
    monthName: function (value) {
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return months[value - 1] || '' // Subtract 1 to match array index
    }
  }
}
</script>
